import { ChangeDetectionStrategy, Component, input } from "@angular/core";

@Component({
  selector: "max-validation-error",
  standalone: false,
  templateUrl: "./max-validation-error.component.html",
  styleUrl: "./max-validation-error.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MaxValidationErrorComponent {
  public label = input.required<string>();
  public max = input.required<number>();

  constructor() {}
}
